<script setup lang="ts">
import type { Property } from "~/classes/entity"

import { propertyIcon, propertyName } from "~/classes/entity"

const props = defineProps({
  sort: null
})

const name = computed(() => propertyName(props.sort.propertyId as Property))
const icon = computed(() => propertyIcon(props.sort.propertyId as Property))
</script>

<template>
  <div class="sort">
    <icon-property :type="icon" size="2xs" />
    <div class="name">
      {{ name }}
    </div>
    <icon-action v-if="sort.descending" type="arrow-down" />
    <icon-action v-else type="arrow-up" />
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.sort
  @apply flex items-center gap-1
</style>
